import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { Store, select } from '@ngrx/store'
import { FetchSwitchableDataCyclesRequest } from '@shared/shared.actions'
import { getSwitchableDataCyclesState } from '@shared/shared.select'
import Validator from '@shared/validatorjs/src/validator'
import { Map } from 'immutable'
import { Observable, Subscription } from 'rxjs'
import FormTrait from 'src/app/traits/form.trait'
import { FetchSettingsRequest } from './../../settings/settings.actions'
import {
  FetchBatchTaskStatusRequest,
  FetchDataCycleStatsRequest,
  FetchInitSwitchStatsRequest,
  SetDefaultData,
  StopDataCycleSwitchingRequest,
  SwitchDataCycleRequest,
  UpdateField,
} from './../data-cycles.actions'
import { DataCycle } from './../data-cycles.interface'
import { getSwitchDataCycleState } from './../data-cycles.selectors'
import { isContentEditableEnabled } from '@containers/i18n/store/i18n.selector'

@Component({
  selector: 'app-switch-data-cycle',
  templateUrl: './switch-data-cycle.component.html',
  styleUrls: ['./switch-data-cycle.component.css'],
})
export class SwitchDataCycleComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  public isStatsLoading: boolean
  private state$: Subscription
  private settings$: Subscription
  public dataCycles$: Observable<DataCycle[]>
  public currentDataCycleId: number
  public stats: any[] = []
  public statusTimeout: any
  public statusInterval: any
  public isNotRunningCount = 0
  public isTranslationActive: boolean
  public isTranslationActive$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  checkIfRunning() {
    return this.stats.reduce(
      (prev, stat) => prev || stat.state.name === 'RUNNING',
      false,
    )
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('switchDataCycle'))
    this.isTranslationActive$ = this.store
      .pipe(select(isContentEditableEnabled))
      .subscribe((isTranslationActive) => {
        this.isTranslationActive = isTranslationActive
      })
    this.dataCycles$ = this.store.pipe(select(getSwitchableDataCyclesState))
    this.state$ = this.store
      .pipe(select(getSwitchDataCycleState))
      .subscribe((state) => {
        this.state = state
        this.stats = state.get('stats').toJS()
        this.isLoading = state.get('isLoading')
        this.isStatsLoading = state.get('isStatsLoading')
      })

    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((settings) => {
        this.currentDataCycleId = settings.getIn([
          'data',
          'system',
          'SYSTEM_ACTIVE_DATA_CYCLE',
          'id',
        ])
        this.handleFieldChange(this.currentDataCycleId, 'dataCycleId')
      })
    this.store.dispatch<any>(new FetchSwitchableDataCyclesRequest())
    this.store.dispatch<any>(new FetchInitSwitchStatsRequest())

    this.statusInterval = setInterval(() => {
      if (!this.isTranslationActive) {
        this.store.dispatch<any>(new FetchBatchTaskStatusRequest())
      }
    }, 1000)
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.settings$.unsubscribe()
    this.isTranslationActive$.unsubscribe()

    clearInterval(this.statusInterval)
  }

  public start() {
    this.store.dispatch<any>(
      new SwitchDataCycleRequest(
        this.state.getIn(['data', 'dataCycleId']) as number,
      ),
    )
  }
  public stop() {
    this.store.dispatch<any>(new StopDataCycleSwitchingRequest())
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'switchDataCycle.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'switchDataCycle',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {}
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      // this.store.dispatch(new UpdateSettingsRequest(this.userId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
